/* eslint-disable no-console */
/* eslint-disable indent */
import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration object
 */
export const MSAL_CONFIG: Configuration = {
    auth: {
        clientId: '',
        authority: '',
        redirectUri: window.location.origin,
        navigateToLoginRequestUrl: false,
        knownAuthorities: [],
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            loggerCallback: (
                level: LogLevel,
                message: string,
                containsPii: boolean
            ): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
    },
};
